import { DataService } from './dataService'
const menuService = {
	addMenu: async (data) => {
		return DataService.post('/admin/add_menu', data)
	},
	getMenu: async (data) => {
		return DataService.get('/admin/get_menu' ,data)
	},
}

export default menuService